module.exports = __webpack_public_path__ + "static/media/upload_photo.a1b36e4c.svg";